import classNames from "classnames";
import React from "react";

const MobileSplashScreen =
    ({
        header, body, backgroundImage, headerFont, bodyFont, backgroundColor, textColor, viewportHeight
    }) => (
        <div className="relative">
            <div className="absolute" style={{  width: '100%', height: `${viewportHeight}px`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundImage: `url(${backgroundImage})`, backgroundColor: `${backgroundColor}`}}>
                <div className={classNames('header break-words text-center', headerFont)}
                     style={{ marginTop:'28vh', color: `${textColor}`, paddingLeft: '2vw', paddingRight:'2vw', fontSize: '10vw' }} id="div_id">{header}</div>
                <div className={classNames('body px-2 break-words text-center', bodyFont)}
                     style={{ marginTop:'12vh',color: `${textColor}`,  paddingLeft: '2vw', paddingRight:'2vw', fontSize: '8vw' }}>{body}</div>
                <div className="footer" style={{ position:'absolute', bottom: 0, fontSize: '3vw', marginBottom: '3vh', marginLeft: '5vw'}}>Powered by Cheqit</div>
            </div>
        </div>
    )

export default MobileSplashScreen
